import React from "react";
import { useParams, useHistory } from "react-router-dom";
import PanelTitle from "components/elements/PanelTitle";
import Panel from "components/elements/Panel";
import PanelFooter from "components/elements/PanelFooter";
import Button from "components/elements/Button";

export default function OrderCompleted() {
	let { projectId } = useParams();
	const history = useHistory()

	const goToProjectOverview = () => {
		history.push(`/projects/${projectId}/overview`);
	}

	return (
		<Panel className="text-base">
			<PanelTitle>Thank you for your order!</PanelTitle>
			<p>Your order has been successfully placed, and we're getting to work right away. Here's what you can expect next:</p><br/>
			<h2 className="font-semibold mb-6">What's next?</h2>
			<p className="mb-2"><strong>Order confirmation via email 📩</strong></p>
			<p className="mb-6">You'll receive an email with your order details within a few minutes. If you don’t see it, please check your spam folder.</p>
			<p className="mb-2"><strong>We’ll schedule the recording 🎙️</strong></p>
			<p className="mb-6">We’ll start planning the session with your selected voice over talent. As soon as the recording date is confirmed, we’ll get in touch with you.</p>
			<p className="mb-2"><strong>Want to attend the recording session? 🎧</strong></p>
			<p className="mb-6">In many cases, it’s possible to join the session (either on-site or remotely) to listen in or give live direction. If you’d like to do this, please let us know as soon as possible.</p>
			<p className="mb-2"><strong>Final delivery ⏳</strong></p>
			<p>After the session, the audio will be professionally edited and prepared for delivery.</p>
			<ul className="my-4 pl-8 list-disc text-xs">
				<li><p><strong>Smaller projects:</strong> Often delivered the same day as the recording.</p></li>
				<li><p><strong>Larger projects:</strong> Delivered within a few business days.</p></li>
			</ul>
			<p className="mb-6">We’ll keep you updated as soon as your files are ready.</p>
			<p className="mb-2"><strong>💬 Questions or additional input?</strong></p>
			<p>Do you have questions about your order, want to attend the session, or have any extra instructions? Feel free to contact us at <a className="underline text-cobalt-500 hover:no-underline hover:text-cobalt-400" href="mailto:support@finetune.audio">support@finetune.audio</a>.</p>
			<PanelFooter>
				<Button type='primary' onClick={goToProjectOverview}>Back to Project</Button>
			</PanelFooter>
		</Panel>
	)
}
